// src/components/CustomTableSearch.tsx
import React from 'react';
import {  Box, FormControl, IconButton,  } from '@mui/material';
import {  AppTextField} from '@/components';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';

const SearchBox = styled(FormControl)(({  }) => ({
  display: 'inline-flex', 
  alignSelf: 'center', 
  '&:not(:last-child)': { 
    mr: 2,
  }
}));

const SearchBoxWrap = styled(Box)(({  }) => ({
  display: 'inline-flex', 
  position: 'relative', 
  width: 276,
}));

// Define props interface for CustomTableSearch
interface CustomTableSearchProps {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CustomTableSearch: React.FC<CustomTableSearchProps> = (props) => {
  return (
    <SearchBox>
      <SearchBoxWrap>
        <IconButton type="submit" aria-label="search" sx={{ display: 'inline-flex', position: 'absolute', top: 1, left: 2, zIndex: 2, width: 34, height: 33, justifyContent: 'center', alignItems: 'center', backgroundColor: 'transparent !important', borderRadius: '8px 0 0 8px', }}>
          <SearchIcon fontSize="small" sx={{ color: "#606B85", position: 'relative', top: 1, }} />
        </IconButton>
        <AppTextField
          label=" "
          placeholder="Search"
          type="text"
          value=""
          {...props}
          sx={{
            position: 'relative',
            '& .MuiInputBase-root': {
              marginTop: '0px !important',
              backgroundColor: '#FAFAFA !important',
              pl: 3.25,
              '& .MuiInputBase-input': {
                minHeight: '36px !important',
                py: '6px !important',
                fontSize: 14,
                backgroundColor: '#FAFAFA !important',
              },
              '& fieldset':{
                top: 0,
                '&:before':{
                  content:'""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: 34,
                  height: '100%',
                  backgroundColor: '#F4F4F6',
                  zIndex: 1,
                },
                '& legend':{
                  display: 'none',
                }
              },
            },
          }}
        />
      </SearchBoxWrap>
    </SearchBox>
  );
};

export default CustomTableSearch;
